import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import PreMeeting from '../PreMeeting/PreMeeting'
import { AttendActivityContainer } from 'LiveBoard/components/shared/LiveEvent/AttendActivity'
import { getActivityType, EVENT_TYPES } from 'LiveBoard/components/shared/LiveEvent/AttendActivity/helpers'

import './style.css.scss'

const onRemove = (element, callback) => {
  const parent = element.parentNode
  if (!parent) {
    return
  }

  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      for (const el of mutation.removedNodes) {
        if (el === element) {
          observer.disconnect()
          callback()
        }
      }
    }
  })
  observer.observe(parent, {
    childList: true
  })
}

function getOrCreateMeetingSDKElement() {
  let meetingSDKElement
  if (window.meetingSDKElement) {
    meetingSDKElement = window.meetingSDKElement
  } else {
    meetingSDKElement = document.createElement('div')
    meetingSDKElement.id = 'meetingSDKElement'
    window.meetingSDKElement = meetingSDKElement
  }
  return meetingSDKElement
}

const ZoomMeeting = (props) => {
  const ZoomMtgEmbedded = window.ZoomMtgEmbedded
  const isZoomScriptLoaded = typeof ZoomMtgEmbedded !== 'undefined'
  if (!isZoomScriptLoaded) return null
  const [meetingLoaded, setMeetingLoaded] = useState(false)
  const isClientInitialized = ZoomMtgEmbedded.embeddedClient != null
  const client = ZoomMtgEmbedded.embeddedClient || ZoomMtgEmbedded.createClient()
  const meetingSDKElement = getOrCreateMeetingSDKElement()

  useEffect(() => {
    if (!isClientInitialized) {
      initClient()
    }
    appendZoomElement()
    joinToMeeting()
  }, [])

  useEffect(() => {
    !props.showZoomClient && leaveMeeting()
  }, [props.showZoomClient])

  const appendZoomElement = () => {
    const meetingSDKElementContainer = document.getElementById('meetingSDKElementContainer')
    meetingSDKElementContainer.appendChild(meetingSDKElement)
  }

  const initClient = () => {
    client.init({
      debug: true,
      zoomAppRoot: meetingSDKElement,
      language: 'en-US',
      customize: {
        meetingInfo: ['topic', 'host', 'mn', 'pwd', 'telPwd', 'invite', 'participant', 'dc', 'enctype'],
        video: {
          defaultViewType: 'gallery',
          isResizable: false,
          viewSizes: {
            default: {
              width: 1050,
              height: 730
            }
          }
        }
      }
    })
      .catch(() => {
        props.onMeetingError()
      })
  }

  const joinToMeeting = () => {
    const joinParams = props.eventUrls.api_params

    client.join({
      sdkKey: joinParams.sdkKey,
      signature: joinParams.signature,
      meetingNumber: joinParams.mn,
      password: joinParams.pwd,
      userName: joinParams.name,
      userEmail: joinParams.email
    })
      .then(() => {
        setMeetingLoaded(true)
        detectDisconnection()
      })
      .catch((e) => {
        console.error(e)
        props.onMeetingError()
      })
  }

  const detectDisconnection = () => {
    const element = meetingSDKElement.children[0]
    onRemove(element, leaveMeeting)
  }

  const leaveMeeting = () => {
    client.leaveMeeting().then(() => {
      props.onParticipantLeave()
    })
  }

  return (
    <>
      <div className={`live-event-embedded ${meetingLoaded ? '' : 'meeting-loading'}`}>
        <AttendActivityContainer
          themeColorHex={props.themeColorHex}
          attendActivityConfig={props.config.attend_activity}
          boardId={props.boardId}
          activityType={getActivityType(EVENT_TYPES.zoom)}
          hasAttendActivity={props.hasAttendActivityOverlay} />
        <div id="meetingSDKElementContainer" />
      </div>

      { !meetingLoaded &&
        <PreMeeting
          title={props.config.placeholder.title}
          themeColorHex={props.themeColorHex} /> }
    </>
  )
}

ZoomMeeting.propTypes = {
  config: PropTypes.object,
  eventUrls: PropTypes.object.isRequired,
  onParticipantLeave: PropTypes.func.isRequired,
  onMeetingError: PropTypes.func.isRequired,
  themeColorHex: PropTypes.string,
  showZoomClient: PropTypes.bool.isRequired,
  boardId: PropTypes.number.isRequired,
  hasAttendActivityOverlay: PropTypes.bool
}

export default ZoomMeeting
